<template>
    <div class="bid-procurement-plan-info">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left">
            <div class="part">
                <div class="title">基本信息</div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label">分公司：</div>
                        <div class="value">{{ ruleForm.companyName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">经营中心：</div>
                        <div class="value">{{ ruleForm.centerName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">服务平台：</div>
                        <div class="value">{{ ruleForm.siteName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">来源：</div>
                        <div class="value">{{ ruleForm.lineSource_ }}</div>
                    </div>
                    <div class="item">
                        <div class="label">招采计划流水号：</div>
                        <div class="value">{{ ruleForm.planBatchNo }}</div>
                    </div>
                </div>
            </div>
            <div class="part" v-if="isBusiness">
                <div class="title">上游信息</div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('projectCode') }">项目编码：</div>
                        <el-button type="text" size="mini" @click="handleLink('projectCode')">{{ ruleForm.projectCode }}</el-button>
                        <i v-if="!!ruleForm.projectCode" class="el-icon-document-copy" @click="handleCopy(ruleForm.projectCode)"></i>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('opportunityCode') }">商机编码：</div>
                        <div class="value">{{ ruleForm.opportunityCode }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('projectStatus') }">项目状态：</div>
                        <div class="value">{{ ruleForm.projectStatus_ }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('operatingProvName') }">运作省份：</div>
                        <div class="value">{{ ruleForm.operatingProvName }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('operatingCityName') }">运作城市：</div>
                        <div class="value">{{ ruleForm.operatingCityName }}</div>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('industryType') }">行业类型：</div>
                        <div class="value">{{ ruleForm.industryType_ }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('bigCdBusinessType') }">业务大类：</div>
                        <div class="value">{{ ruleForm.bigCdBusinessType_ }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('businessType') }">业务类型：</div>
                        <div class="value">{{ ruleForm.businessType_ }}</div>
                    </div>
                    <div class="item" v-if="!isEdit">
                        <div class="label" :class="{ marked: getMarked('professionalCompany') }">专业公司：</div>
                        <div class="value">{{ ruleForm.professionalCompany_ }}</div>
                    </div>
                    <div class="item" v-else>
                        <el-form-item label="专业公司：" prop="professionalCompany" label-width="76px" class="mb-20">
                            <MSelect
                                :optionNum="'SYS_PROFESSIONAL_COMPANY'"
                                :value="ruleForm.professionalCompany"
                                :filterable="true"
                                :disabled="!isEdit || disabledKeys.includes('professionalCompany')"
                                @input="getProfessionalCompany"
                            ></MSelect>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('customerName') }">客户名称：</div>
                        <div class="value">{{ ruleForm.customerName }}</div>
                    </div>
                </div>
                <div class="flex-row">
                    <div v-if="!isEdit" class="item">
                        <div class="label" :class="{ marked: getMarked('expectedSize') }">年度规模（元）：</div>
                        <div class="value">{{ ruleForm.expectedSize }}</div>
                    </div>
                    <div v-else class="item">
                        <el-form-item label="年度规模（元）：" prop="expectedSize" label-width="114px">
                            <el-input
                                v-model.trim="ruleForm.expectedSize"
                                :disabled="disabledKeys.includes('expectedSize')"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('cdBidScale') }">上游实际中标规模（万元）：</div>
                        <div class="value">{{ ruleForm.cdBidScale }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('actualBidProcurementGrossMargin') }">上游实际中标采购毛利率(%)：</div>
                        <div class="value">{{ ruleForm.actualBidProcurementGrossMargin }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('upstreamContractStartTime') }">上游合同开始时间：</div>
                        <div class="value">{{ ruleForm.upstreamContractStartTime }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('upstreamContractEndTime') }">上游合同结束时间：</div>
                        <div class="value">{{ ruleForm.upstreamContractEndTime }}</div>
                    </div>
                </div>
            </div>
            <div class="part" v-if="isContract">
                <div class="title">原合同信息</div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('legalContractCode') }">合同号（原）：</div>
                        <el-button type="text" size="mini" @click="handleLink('legalContractCode')">{{ ruleForm.legalContractCode }}</el-button>
                        <i v-if="!!ruleForm.legalContractCode" class="el-icon-document-copy" @click="handleCopy(ruleForm.legalContractCode)"></i>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('operatingProvName') }">运作省份：</div>
                        <div class="value">{{ ruleForm.operatingProvName }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('operatingCityName') }">运作城市：</div>
                        <div class="value">{{ ruleForm.operatingCityName }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('businessType') }">业务类型：</div>
                        <div class="value">{{ ruleForm.businessType_ }}</div>
                    </div>
                    <div class="item" v-if="!isEdit">
                        <div class="label" :class="{ marked: getMarked('professionalCompany') }">专业公司：</div>
                        <div class="value">{{ ruleForm.professionalCompany_ }}</div>
                    </div>
                    <div class="item" v-else>
                        <el-form-item label="专业公司：" prop="professionalCompany" label-width="76px" class="mb-20">
                            <MSelect
                                :optionNum="'SYS_PROFESSIONAL_COMPANY'"
                                :value="ruleForm.professionalCompany"
                                :filterable="true"
                                :disabled="!isEdit || disabledKeys.includes('professionalCompany')"
                                @input="getProfessionalCompany"
                            ></MSelect>
                        </el-form-item>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('customerName') }">客户名称：</div>
                        <div class="value">{{ ruleForm.customerName }}</div>
                    </div>
                    <div v-if="!isEdit" class="item">
                        <div class="label" :class="{ marked: getMarked('expectedSize') }">年度规模（元）：</div>
                        <div class="value">{{ ruleForm.expectedSize }}</div>
                    </div>
                    <div v-else class="item">
                        <el-form-item label="年度规模（元）：" prop="expectedSize" label-width="114px">
                            <el-input
                                v-model.trim="ruleForm.expectedSize"
                                :disabled="disabledKeys.includes('expectedSize')"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('cdBidScale') }">上游实际中标规模（万元）：</div>
                        <div class="value">{{ ruleForm.cdBidScale }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('actualBidProcurementGrossMargin') }">上游实际中标采购毛利率(%)：</div>
                        <div class="value">{{ ruleForm.actualBidProcurementGrossMargin }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('upstreamContractStartTime') }">原合同开始时间：</div>
                        <div class="value">{{ ruleForm.upstreamContractStartTime }}</div>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('upstreamContractEndTime') }">原合同结束时间：</div>
                        <div class="value">{{ ruleForm.upstreamContractEndTime }}</div>
                    </div>
                </div>
            </div>
            <div class="part">
                <div class="title">招采计划</div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('planAuditStatus') }">招采计划审批状态：</div>
                        <div v-if="isAudit" class="value">{{ ruleForm.planAuditStatus_ }}</div>
                        <el-button v-else type="text" size="mini" @click="handleLink('planAuditStatus')">{{ ruleForm.planAuditStatus_ }}</el-button>
                    </div>
                    <div class="item">
                        <el-form-item label="招标方式：" prop="bidPlanType" label-width="76px" class="mb-20" :class="{ marked: getMarked('bidPlanType') }">
                            <MSelect
                                :optionNum="'SU_BID_PLAN_TYPE'"
                                :value="ruleForm.bidPlanType"
                                :filterable="true"
                                :disabled="!isEdit || disabledKeys.includes('bidPlanType')"
                                :showDisabledOptions="false"
                                :disabledOptions="['30']"
                                @input="getBidPlanType"
                            ></MSelect>
                        </el-form-item>
                    </div>
                    <div class="item" v-if="!isEdit">
                        <div class="label" :class="{ marked: getMarked('priceFixUrl') }">定价链接：</div>
                        <div class="value url-value">{{ ruleForm.priceFixUrl }}</div>
                        <i v-if="ruleForm.priceFixUrl && ruleForm.priceFixUrl.length" class="el-icon-document-copy" @click="handleCopy(ruleForm.priceFixUrl)"></i>
                    </div>
                </div>
                <div class="flex-row" v-if="isEdit">
                    <div class="item item-full">
                        <el-form-item label="定价链接：" prop="priceFixUrl" label-width="76px" class="mb-20">
                            <el-input
                                type="textarea"
                                :rows="3"
                                v-model.trim="ruleForm.priceFixUrl"
                                :disabled="disabledKeys.includes('priceFixUrl')"
                                maxlength="1000"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="item item-full">
                        <el-form-item label="备注：" prop="remark" label-width="76px" class="mb-20" :class="{ marked: getMarked('remark') }">
                            <el-input
                                type="textarea"
                                :rows="2"
                                v-model.trim="ruleForm.remark"
                                :disabled="!isEdit || disabledKeys.includes('remark')"
                                maxlength="500"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="part">
                <div class="title">招标方案</div>
                <div class="flex-row">
                    <div class="item" v-if="!isEdit">
                        <div class="label" :class="{ marked: getMarked('bidNo') }">招标编码：</div>
                        <el-button type="text" size="mini" @click="handleLink('bidNo')">{{ ruleForm.bidNo }}</el-button>
                        <i v-if="!!ruleForm.bidNo" class="el-icon-document-copy" @click="handleCopy(ruleForm.bidNo)"></i>
                    </div>
                    <div class="item" v-else>
                        <el-form-item label="招标编码：" prop="bidNo" label-width="76px">
                            <SrmAdvance
                                :mValue="ruleForm.bidNo"
                                :params="bidNoAdvanceConfig"
                                :disabled="disabledKeys.includes('bidNo')"
                                @getAdvanceValue="getBidAdvanceValue" />
                        </el-form-item>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('bidName') }">招标名称：</div>
                        <div class="value">{{ ruleForm.bidName }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('noticeStatus') }">公告审批状态：</div>
                        <div v-if="isAudit" class="value">{{ ruleForm.noticeStatus_ }}</div>
                        <el-button v-else type="text" size="mini" @click="handleLink('noticeStatus')">{{ ruleForm.noticeStatus_ }}</el-button>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('bidStatus') }">招标状态：</div>
                        <div class="value">{{ ruleForm.bidStatus_ }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('bidMeetingPlanStartTime') }">标前会时间：</div>
                        <div class="value">{{ ruleForm.bidMeetingPlanStartTime }}</div>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('pushTime') }">招标公告发布时间：</div>
                        <div class="value">{{ ruleForm.pushTime }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('bidTenderTime') }">招标时间：</div>
                        <div class="value">{{ ruleForm.bidTenderTime }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('awardOfBidTime') }">决标时间：</div>
                        <div class="value">{{ ruleForm.awardOfBidTime }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('inviteNum') }">邀标数量：</div>
                        <div class="value">{{ ruleForm.inviteNum }}</div>
                    </div>
                </div>
            </div>
            <div class="part">
                <div class="title">下游信息</div>
                <div class="flex-row">
                    <div class="item" v-if="!isEdit">
                        <div class="label" :class="{ marked: getMarked('downstreamContractCode') }">下游合同单据编号：</div>
                        <el-button type="text" size="mini" @click="handleLink('downstreamContractCode')">{{ ruleForm.downstreamContractCode }}</el-button>
                        <i v-if="!!ruleForm.downstreamContractCode" class="el-icon-document-copy" @click="handleCopy(ruleForm.downstreamContractCode)"></i>
                    </div>
                    <div class="item" v-else>
                        <el-form-item label="下游合同单据编号：" prop="downstreamContractCode" label-width="128px">
                            <SrmAdvance
                                :mValue="ruleForm.downstreamContractCode"
                                :params="contractAdvanceConfig"
                                :formData="{ applyType: '1' }"
                                :disabled="disabledKeys.includes('downstreamContractCode')"
                                @getAdvanceValue="getContractAdvanceValue"
                            />
                        </el-form-item>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('downstreamLegalContractCode') }">下游合同号（新）：</div>
                        <div class="value">{{ ruleForm.downstreamLegalContractCode }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('downstreamContractStatus') }">合同状态：</div>
                        <div class="value">{{ ruleForm.downstreamContractStatus_ }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('downstreamContractStartTime') }">下游合同开始时间：</div>
                        <div class="value">{{ ruleForm.downstreamContractStartTime }}</div>
                    </div>
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('downstreamContractEndTime') }">下游合同结束时间：</div>
                        <div class="value">{{ ruleForm.downstreamContractEndTime }}</div>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="item">
                        <div class="label" :class="{ marked: getMarked('downstreamContractSupplierName') }">供应商名称：</div>
                        <el-button type="text" size="mini" @click="handleLink('downstreamContractSupplierName')">{{ ruleForm.downstreamContractSupplierName }}</el-button>
                        <i v-if="!!ruleForm.downstreamContractSupplierName" class="el-icon-document-copy" @click="handleCopy(ruleForm.downstreamContractSupplierName)"></i>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="part" v-if="isDetail || isAudit">
            <div class="title">操作记录</div>
            <div class="flex-row">
                <div class="item">
                    <div class="label">创建人：</div>
                    <div class="value">{{ ruleForm.createUserName }}</div>
                </div>
                <div class="item">
                    <div class="label">创建时间：</div>
                    <div class="value">{{ ruleForm.createTime }}</div>
                </div>
            </div>
            <div class="table">
                <vxe-table
                    v-loading="recordLoading"
                    border
                    size="mini"
                    ref="tableRef"
                    :data="tableData"
                    align="center"
                    :column-config="{ resizable: true }"
                    show-overflow
                    max-height="395"
                >
                    <vxe-column field="createUserName" title="修改人"></vxe-column>
                    <vxe-column field="updateTime" title="修改时间"></vxe-column>
                    <vxe-column field="operationFieldName" title="修改字段"></vxe-column>
                    <vxe-column field="auditStatus_" title="招采计划修改审批状态" width="180px"></vxe-column>
                    <vxe-column title="操作" width="100px" v-if="isDetail">
                        <template #default="scope">
                            <el-button type="text" @click="handleCheckMip(scope.row)">查看审批流程</el-button>
                        </template>
                    </vxe-column>
                </vxe-table>
                <div class="page">
                    <el-pagination
                        @size-change="sizeChange"
                        @current-change="pageChange"
                        :current-page="pageNo"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <el-input class="copy-input" v-model="copyText" ref="ctRef"></el-input>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import { dictWithUrl } from '@/components/lots/api'
import MSelect from '@/components/lots/otpSelect2';
import SrmAdvance from '../../../components/srmAdvance/index.vue'
// import Preview from '../../../../components/viewAttachment.vue'
import { queryDetailInfoById, operationLogPage, changeInfoByFdId } from '../../../api/tendering/biddingProcurementPlan.js'
import { tenderEnquiry } from '../../../api/tenderEnquiry.js'

// SU_BID_PLAN_TYPE
const INV_BID = '10' // 邀请招标
const PUB_BID = '20' // 公开招标
const BARG_BID = '40' // 议价招标
const TMN_BID = '50' // 终止
const NOT_LOAD_BID = '60' // 非装卸招标项目

const INIT_FORM = {
    companyName: '', // 分公司
    centerName: '', // 经营中心
    siteName: '', // 服务平台
    lineSource: '', // 来源
    planBatchNo: '', // 招采计划流水号
    projectCode: '', // 项目编码
    opportunityCode: '', // 商机编码
    projectStatus: '', // 项目状态
    operatingProvName: '', // 运作省份
    operatingCityName: '', // 运作城市
    industryType: '', // 行业类型
    bigCdBusinessType: '', // 业务大类
    businessType: '', // 业务类型
    professionalCompany: '', // 专业公司
    customerName: '', // 客户名称
    expectedSize: '', // 年度规模（元）
    cdBidScale: '', // 上游实际中标规模（万元）
    actualBidProcurementGrossMargin: '', // 上游实际中标采购毛利率
    upstreamContractStartTime: '', // 上游合同开始时间
    upstreamContractEndTime: '', // 上游合同结束时间
    planAuditStatus: '', // 招采计划审批状态
    bidPlanType: '', // 招标方式
    priceFixUrl: '', // 定价链接
    remark: '', // 备注
    bidNo: '', // 招标编码
    bidName: '', // 招标名称
    noticeStatus: '', // 公告审批状态
    bidStatus: '', // 招标状态
    bidMeetingPlanStartTime: '', // 标前会时间
    pushTime: '', // 招标公告发布时间
    bidTenderTime: '', // 招标时间
    awardOfBidTime: '', // 决标时间
    inviteNum: '', // 邀标数量
    downstreamContractCode: '', // 下游合同单据编号
    downstreamLegalContractCode: '', // 下游合同号（新）
    downstreamContractStatus: '', // 合同状态
    downstreamContractStartTime: '', // 下游合同开始时间
    downstreamContractEndTime: '', // 下游合同结束时间
    downstreamContractSupplierName: '', // 供应商名称
    createUserName: '', // 
    createTime: '', // 
    legalContractCode: '', // 合同号（原）

    planFdId: '',
    noticeFdId: '',
}

// SU_BID_PLAN_LINE_SOURCE
const BUSINESS = '3' // 商机
const CONTRACT = '4' // 合同

export default {
    components: { MSelect, SrmAdvance },
    props: {
        type: {
            type: String,
            default() {
                return '';
            }
        },
        bidPlanId: {
            type: String,
            default() {
                return '';
            }
        },
        fdId: {
            type: String,
            default() {
                return '';
            }
        },
    },
    data() {
        return {
            initialInfo: {}, // 详情数据初始值
            ruleForm: { ...INIT_FORM },
            bidNoAdvanceConfig: {
                name: '招标编码',
                value: 'bidNo',
                advanceLabel: '招标编码弹出框',
                advanceConfig: [
                    { prop: 'noticeCode', value: '招标编码' },
                    { prop: 'noticeTitle', value: '招标名称' },
                ],
                tableConfig: [
                    { prop: 'noticeCode', value: '招标编码' },
                    { prop: 'noticeTitle', value: '招标名称' },
                ],
                prefix: '/api-srm-web',
                method: 'post',
                advanceUrl: '/bid/notice/plan/query',
                cbParams: [
                    'noticeCode#bidNo',
                    'noticeTitle#bidName',
                    'noticeStatus#noticeStatus',
                    'noticeFdId#noticeFdId',
                    'bidStatus#bidStatus',
                    'bidMeetingPlanStartTime#bidMeetingPlanStartTime',
                    'pushTime#pushTime',
                    'bidTenderTime#bidTenderTime',
                    'awardOfBidTime#awardOfBidTime',
                    'downstreamContractCode#downstreamContractCode',
                    'downstreamLegalContractCode#downstreamLegalContractCode',
                    'downstreamContractStatus#downstreamContractStatus',
                    'downstreamContractSupplierName#downstreamContractSupplierName',
                    'downstreamContractStartTime#downstreamContractStartTime',
                    'downstreamContractEndTime#downstreamContractEndTime',
                ],
            },
            contractAdvanceConfig: {
                name: '单据编码',
                value: 'downstreamContractCode',
                advanceConfig: [{ prop: 'contractCode', value: '单据编码' }],
                tableConfig: [
                    { prop: 'contractCode', value: '单据编码' },
                    { prop: 'contractName', value: '合同名称' },
                ],
                advanceUrl: '/contract/contractInfo/queryContractList',
                advanceCascade: 'applyType,legalContractCodeNotNullFlag',
                cbParams: [
                    'legalContractCode#downstreamLegalContractCode',
                    'contractCode#downstreamContractCode',
                    'contractStatus#downstreamContractStatus',
                    'effectiveDate#downstreamContractStartTime',
                    'expirationDate#downstreamContractEndTime',
                    'suppliersName#downstreamContractSupplierName',
                ],
                method: 'post',
                prefix: 'api-srm-web',
            },
            dictMap: [
                { key: 'lineSource', code: 'SU_BID_PLAN_LINE_SOURCE' },
                { key: 'projectStatus', code: 'SRM_CUSTOMER_PROJECT_STATUS' },
                { key: 'industryType', code: 'SYS_INDUSTRY_TYPE', multiple: true },
                { key: 'bigCdBusinessType', code: 'SRM_BUS_TYPE', multiple: true },
                { key: 'businessType', code: 'BID_BUSINESS_TYPE', multiple: true },
                { key: 'professionalCompany', code: 'SYS_PROFESSIONAL_COMPANY' },
                { key: 'planAuditStatus', code: 'SYS_BMS_NEW_MIP_STATUS' },
                { key: 'noticeStatus', code: 'SYS_BMS_NEW_MIP_STATUS' },
                { key: 'bidStatus', code: 'BID_STATUS' },
                { key: 'downstreamContractStatus', code: 'SRM_CONTRACT_STATUS' },
            ],
            dictData: {},
            recordLoading: false,
            tableData: [],
            totalCount: 0,
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                layout: 'total, sizes, prev, pager, next, jumper',
                pageSize: 10,
                pageSizes: [10, 20, 30, 50, 100]
            },
            changeFieldEnList: [], // 审批时需标红的字段
            copyText: '',
        }
    },
    computed: {
        isDetail() {
            return this.type === 'detail'
        },
        isEdit() {
            return this.type === 'edit'
        },
        isAudit() {
            return !!this.fdId
        },
        isBusiness() {
            return String(this.ruleForm.lineSource) === BUSINESS
        },
        isContract() {
            return String(this.ruleForm.lineSource) === CONTRACT
        },
        rules() {
            const ruleTemp = {
                expectedSize: [
                    { required: false, message: '该项必填', trigger: ['blur', 'change'] },
                    {
                        validator: (rule, value, callback) => {
                            if (['', null, undefined].includes(value) || (/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 1000000000)) {
                                callback();
                            } else {
                                callback(new Error('请输入1~1000000000正整数'));
                            }
                        }, trigger: ['blur', 'change']
                    }
                ],
                professionalCompany: [{ required: true, message: '该项必填', trigger: ['blur', 'change'] }],
                bidPlanType: [{ required: true, message: '该项必填', trigger: ['blur', 'change'] }],
                remark: [{ required: [TMN_BID, NOT_LOAD_BID].includes(this.ruleForm.bidPlanType), message: '该项必填', trigger: ['blur', 'change'] }],
                priceFixUrl: [{
                    required: this.ruleForm.bidPlanType === BARG_BID,
                    message: '该项必填',
                    trigger: ['blur', 'change']
                }],
                bidNo: [{
                    required: [INV_BID, PUB_BID].includes(this.ruleForm.bidPlanType) && !!this.ruleForm.noticeStatus,
                    message: '该项必填',
                    trigger: ['blur', 'change']
                }],
                downstreamContractCode: [{ required: false, message: '该项必填', trigger: ['blur', 'change'] }],
            }
            return this.isEdit ? ruleTemp : {}
        },
        disabledKeys() {
            // 需置灰的字段
            let keys = []
            if (this.ruleForm.bidPlanType === BARG_BID) {
                keys = ['bidNo', 'remark'];
            } else if ([TMN_BID, NOT_LOAD_BID].includes(this.ruleForm.bidPlanType)) {
                keys = ['bidNo', 'priceFixUrl', 'downstreamContractCode'];
            } else if ([INV_BID, PUB_BID].includes(this.ruleForm.bidPlanType)) {
                if (['', null, undefined].includes(this.ruleForm.noticeStatus)) {
                    keys = ['priceFixUrl', 'remark'];
                } else {
                    keys = ['expectedSize', 'priceFixUrl', 'remark'];
                }
                if (!this.ruleForm.bidNo) {
                    keys.push('downstreamContractCode')
                }
            }
            return keys
        },
    },
    methods: {
        loadData() {
            let params = { bidPlanId: this.bidPlanId }
            this.loading = true
            queryDetailInfoById(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.initialInfo = res.data
                        Object.keys(this.ruleForm).forEach(key => {
                            if (['', undefined, null].indexOf(res.data[key]) < 0) {
                                this.ruleForm[key] = res.data[key]
                                if (['downstreamContractStartTime', 'downstreamContractEndTime'].includes(key)) {
                                    this.ruleForm[key] = dayjs(this.ruleForm[key]).format('YYYY-MM-DD')
                                }
                            }
                        })
                        this.translateDictData()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        loadChangeData() {
            let params = { fdId: this.fdId }
            this.loading = true
            changeInfoByFdId(params)
                .then(res => {
                    if (res && +res.code === 0 && res.data.bidPlanDetailInfo) {
                        Object.keys(this.ruleForm).forEach(key => {
                            if (['', undefined, null].indexOf(res.data.bidPlanDetailInfo[key]) < 0) {
                                this.ruleForm[key] = res.data.bidPlanDetailInfo[key]
                            }
                        })
                        this.translateDictData()
                        this.changeFieldEnList = res.data.changeFieldEnList || []
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        translateDictData() {
            this.dictMap.forEach(item => {
                if (this.dictData[item.code] && ['', undefined, null].indexOf(this.ruleForm[item.key]) < 0) {
                    if (item.multiple) {
                        this.ruleForm[item.key + '_'] = this.ruleForm[item.key].split(',')
                            .map(value => this.dictData[item.code][value])
                            .join(',')
                    } else {
                        this.ruleForm[item.key + '_'] = this.dictData[item.code][this.ruleForm[item.key]]
                    }
                } else {
                    this.ruleForm[item.key + '_'] = ''
                }
            })
        },
        reset() {
            Object.keys(this.ruleForm).forEach(key => {
                if (['bidPlanType'].indexOf(key) < 0) {
                    this.ruleForm[key] = this.initialInfo[key] || null
                }
            })
            this.translateDictData()
        },
        loadRecordData() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                bidPlanId: this.bidPlanId,
            }
            this.recordLoading = true
            operationLogPage(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalCount = res.data.totalCount || 0
                        this.tableData = res.data.list.map(item => {
                            item.auditStatus_ = this.dictData.SYS_BMS_NEW_MIP_STATUS[item.auditStatus]
                            return item
                        })
                    }
                })
                .finally(() => {
                    this.recordLoading = false
                })
        },
        pageChange(pageNo) {
            this.pageNo = pageNo;
            this.loadRecordData();
        },
        sizeChange(pageSize) {
            this.pageNo = 1;
            this.pageSize = pageSize;
            this.loadRecordData();
        },
        getBidPlanType(val) {
            this.ruleForm.bidPlanType = val

            this.reset()
            if (
                [INV_BID, PUB_BID].includes(this.initialInfo.bidPlanType) &&
                [BARG_BID, TMN_BID, NOT_LOAD_BID].includes(this.ruleForm.bidPlanType)
            ) {
                [
                    'bidNo', 'bidName', 'noticeStatus', 'noticeStatus_', 'bidStatus', 'bidStatus_',
                    'bidMeetingPlanStartTime', 'pushTime', 'bidTenderTime', 'awardOfBidTime', 'inviteNum',
                    'downstreamLegalContractCode', 'downstreamContractCode', 'downstreamContractStatus', 'downstreamContractStatus_',
                    'downstreamContractSupplierName', 'downstreamContractStartTime', 'downstreamContractEndTime'
                ].forEach(key => {
                    this.ruleForm[key] = ''
                })
            } else if (
                [BARG_BID, TMN_BID, NOT_LOAD_BID].includes(this.initialInfo.bidPlanType) &&
                [INV_BID, PUB_BID].includes(this.ruleForm.bidPlanType)
            ) {
                if (!!this.ruleForm.noticeStatus) {
                    this.ruleForm.priceFixUrl = ''
                } else {
                    [
                        'downstreamContractCode', 'downstreamLegalContractCode', 'downstreamContractStatus', 'downstreamContractStatus_',
                        'downstreamContractSupplierName', 'downstreamContractStartTime', 'downstreamContractEndTime', 'priceFixUrl'
                    ].forEach(key => {
                        this.ruleForm[key] = ''
                    })
                }
            }
        },
        getProfessionalCompany(val) {
            this.ruleForm.professionalCompany = val
        },
        getBidAdvanceValue(val) {
            // 标编码带出字段信息（招标名称，客户名称，专业公司，运作省份，运作城市）
            this.ruleForm.bidNo = val.bidNo
            this.ruleForm.bidName = val.bidName
            this.ruleForm.noticeStatus = val.noticeStatus
            this.ruleForm.noticeFdId = val.noticeFdId
            this.ruleForm.bidStatus = val.bidStatus
            this.ruleForm.bidMeetingPlanStartTime = val.bidMeetingPlanStartTime
            this.ruleForm.pushTime = val.pushTime
            this.ruleForm.bidTenderTime = val.bidTenderTime
            this.ruleForm.awardOfBidTime = val.awardOfBidTime
            this.ruleForm.downstreamContractCode = val.downstreamContractCode
            this.ruleForm.downstreamLegalContractCode = val.downstreamLegalContractCode
            this.ruleForm.downstreamContractStatus = val.downstreamContractStatus
            this.ruleForm.downstreamContractSupplierName = val.downstreamContractSupplierName
            this.ruleForm.downstreamContractStartTime = val.downstreamContractStartTime ?
                dayjs(val.downstreamContractStartTime).format('YYYY-MM-DD') : ''
            this.ruleForm.downstreamContractEndTime = val.downstreamContractEndTime ?
                dayjs(val.downstreamContractEndTime).format('YYYY-MM-DD') : ''
            this.ruleForm.inviteNum = ''
            this.translateDictData()
        },
        getContractAdvanceValue(val) {
            this.ruleForm.downstreamContractCode = val.downstreamContractCode
            this.ruleForm.downstreamLegalContractCode = val.downstreamLegalContractCode
            this.ruleForm.downstreamContractStatus = val.downstreamContractStatus
            this.ruleForm.downstreamContractStartTime = val.downstreamContractStartTime ?
                dayjs(val.downstreamContractStartTime).format('YYYY-MM-DD') : ''
            this.ruleForm.downstreamContractEndTime = val.downstreamContractEndTime ?
                dayjs(val.downstreamContractEndTime).format('YYYY-MM-DD') : ''
            this.ruleForm.downstreamContractSupplierName = val.downstreamContractSupplierName
            this.translateDictData()
        },
        handleCopy(val) {
            if (this.$refs.ctRef) {
                this.copyText = val;
                this.$nextTick(() => {
                    // 选中文本
                    this.$refs.ctRef.select();
                    // 执行复制命令
                    try {
                        document.execCommand('copy');
                        this.$message.info('已复制!');
                    } catch (err) {
                        console.error('复制失败:', err);
                    }
                })
            }
        },
        getData() {
            if (this.$refs.ruleForm) {
                return this.$refs.ruleForm.validate().then(() => {
                    return JSON.parse(JSON.stringify(this.ruleForm))
                })
            } else {
                return Promise.reject()
            }
        },
        handleCheckMip(row) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    path: `/biddingProcurementPlanDetail?bidPlanId=${this.bidPlanId}`,
                    processId: row.fdId,
                    bidPlanId: this.bidPlanId,
                }
            });
        },
        async handleLink(prop) {
            // 项目编码
            if (prop === 'projectCode') {
                this.$router.push({
                    path: '/tenderCostDetails',
                    query: { projectCode: this.ruleForm.projectCode },
                })
            } else if (prop === 'planAuditStatus') {
                // 招采计划审批状态
                if(['', null, undefined].includes(this.ruleForm.planFdId)){
                    this.$message.warning('暂无流程')
                    return
                }
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        path: `/biddingProcurementPlanDetail?bidPlanId=${this.bidPlanId}`,
                        processId: this.ruleForm.planFdId,
                        bidRadioVal: String(this.ruleForm.lineSource),
                    }
                });
            } else if (prop === 'bidNo') {
                // 招标编码
                const bidRes= await tenderEnquiry({ bidNo: this.ruleForm.bidNo }).catch(err => {})
                if (bidRes && +bidRes.code === 0) {
                    let dataList = bidRes.data && bidRes.data.list ? bidRes.data.list : []
                    if (dataList.length) {
                        this.$router.push({
                            path: '/tenderdocument',
                            query: { bidNo: this.ruleForm.bidNo },
                        }) 
                    } else {
                        this.$message.warning('当前招标编码还没生成招标方案，请检查公告')
                    }
                }
            } else if (prop === 'noticeStatus') {
                // 公告审批状态
                if(['', null, undefined].includes(this.ruleForm.noticeFdId)){
                    this.$message.warning('暂无流程')
                    return
                }
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        path: `/biddingProcurementPlanDetail?bidPlanId=${this.bidPlanId}`,
                        processId: this.ruleForm.noticeFdId,
                    }
                });
            } else if (prop === 'downstreamContractCode') {
                // 下游合同单据编号
                this.$router.push({
                    path: '/contractUphold',
                    query: {
                        contractCode_: this.ruleForm.downstreamContractCode,
                        fromPage: 'biddingProcurementPlan'
                    },
                })
            } else if (prop === 'legalContractCode') {
                // 合同号（原）
                this.$router.push({
                    path: '/contractUphold',
                    query: {
                        legalContractCode_: this.ruleForm.legalContractCode,
                        fromPage:'biddingProcurementPlan'
                    },
                })
            } else if (prop === 'downstreamContractSupplierName') {
                // 供应商名称
                this.$router.push({
                    path: '/supplierProfile',
                    query: {
                        supplierName: this.ruleForm.downstreamContractSupplierName,
                        from: 'biddingProcurementPlan'
                    },
                })
            }
        },
        getMarked(prop) {
            return this.changeFieldEnList.includes(prop)
        },
        hasChange() {
            const flag = [
                'professionalCompany',
                'expectedSize',
                'bidPlanType',
                'priceFixUrl',
                'remark',
                'bidNo',
                'downstreamContractCode',
            ].some(key => {
                const initVal = !!this.initialInfo[key] ? String(this.initialInfo[key]) : ''
                const formVal = !!this.ruleForm[key] ? String(this.ruleForm[key]) : ''
                return initVal !== formVal
            })
            return flag
        },
    },
    mounted() {
        const dictCodes = this.dictMap.map(item => item.code).join(',')
        dictWithUrl(dictCodes).then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                if (this.fdId) {
                    this.loadChangeData()
                } else {
                    this.loadData()
                }
                if (this.isDetail || this.isAudit) {
                    this.loadRecordData()
                }
            }
        });
    }
}
</script>
<style lang="less" src="../../../style/vxe-table-style.less"></style>
<style lang="less" scoped>
.bid-procurement-plan-info {
    min-width: 1270px;
    /deep/ .el-form-item {
        margin-bottom: 10px;
    }
    /deep/ .el-form-item__label {
        padding-right: 0px;
        line-height: 28px;
        font-size: 13px;
    }

    /deep/ .el-form-item__content {
        line-height: 28px;
    }

    /deep/ .el-input-group__append {
        padding: 0 14px;
    }

    div.mb-20 {
        margin-bottom: 20px;
    }
}
.title {
    // display: flex;
    // align-items: center;
    margin-bottom: 10px;
    font-size: 14px;

    &::before {
        width: 5px;
        height: 16px;
        background: #00A9AC;
        content: '';
        display: inline-block;
        vertical-align: text-bottom;
        margin-right: 5px;
    }

    // & > div {
    //     padding: 3px 0 3px 6px;
    //     background-image: linear-gradient(to right, #E8F7F8, transparent);
    // }
}
.part {
    margin-bottom: 10px;
}
.flex-row {
    display: flex;
    // margin-bottom: 10px;
}
.item {
    font-size: 13px;
    display: flex;
    width: 20%;
    padding-right: 10px;
    box-sizing: border-box;
    align-items: baseline;
}
.item-full {
    width: 100%;
    /deep/ .el-form-item {
        width: 100%;
    }
}
.label {
    white-space: nowrap;
    color: #555757;
    line-height: 28px;
    &.marked {
        color: #f96c5f;
    }
}
.marked {
    /deep/ .el-form-item__label {
        color: #f96c5f;
    }
}
.url-value {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.el-icon-document-copy {
    cursor: pointer;
    line-height: 28px;
    padding-left: 5px;
    font-size: 15px;
    color: #00bcbf;
}
.copy-input {
    position: absolute;
    z-index: -100;
    bottom: 0;
    width: 20px;
}
.page {
    margin-top: 10px;
    /deep/ .el-pagination {
        text-align: right;
    }
}
</style>